import { Injectable } from '@angular/core';
import { Breed } from '@models/Breed';

import { BreedsStore } from './breeds.store';

@Injectable({ providedIn: 'root' })
export class BreedsService {
	constructor(private readonly store: BreedsStore) { }

	public update(breeds: Breed[]): void {
		this.store.set(breeds);
	}
}
